app.controller(
    'BioTranslationController', ['$scope', '$rootScope', '$stateParams', '$translate', '$window',  'BioService', 'HelperService', 'SideBarService', BioTranslationController]
);

function BioTranslationController($scope, $rootScope, $stateParams, $translate,$window, BioService, HelperService, SideBarService) {
    var vm = this;
    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.DescriptionToTranslate = {};
    vm.SelectedDescriptionStatusItem = {};
    vm.PreviousDescriptionStatusItem = {};

    vm.Bio = {};
    vm.ActiveDescriptionVm =
        {
            Clients: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
            QualificationList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
        };

    $scope.edit = {};
    $scope.item = {};

    $scope.contentTranslate = null;

    $scope.clients = [];
    $scope.classifications = [
    {
        name: 'Art moderne',
        checked: true
    },
    {
        name: 'Haute époque',
        checked: true
    }
    ];

    $scope.item.disaplayName = $scope.item.name || ($scope.item.firstName || $scope.item.lastName);


    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }

    $translate.use($rootScope.LangForInterface);

    if ($stateParams.id) {
        vm.ParamBioId = $stateParams.id;
    }
    else {
        vm.ParamBioId = 1;
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    initController();

    function initController() {        
        loadBio(vm.ParamBioId, $scope.CurrentLang, $rootScope.LangForTranslationDestination, $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    }

    function loadBio(bioId, lang, lang2, index, sortKey, reverse) {
        BioService.GetBio(bioId, lang, lang2, index, sortKey, reverse)
            .then(function (bio) {
                vm.Bio = bio;
                vm.BioOrigin = angular.copy(vm.Bio);

                if (vm.Bio.DescriptionList.length > 0) {
                    vm.ActiveDescriptionId = 0;
                    vm.ActiveDescription = vm.Bio.DescriptionList[vm.ActiveDescriptionId];

                    //load descriptionVm
                    vm.GetDescriptionVm();

                    //load translation description
                    vm.GetDescriptionTranslated();
                }

                $rootScope.Clients = bio.ClientList;
                $rootScope.Comments = bio.CommentList;
                $rootScope.SideBar = bio.SideBar;

                $rootScope.CurrentObjectId = bioId;
                $rootScope.CurrentPageType = $rootScope.EnumLinkType.Bio;
                $rootScope.CurrentObjectStatus = bio.CurrentBioStatus;
                $rootScope.SideBar.CurrentObjectStatus = bio.CurrentBioStatus;
                $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;

                $rootScope.SideBar.bioVmProfessionTranslation = bio.ProfessionTranslation;

                vm.GetAssociatedPlacesOnSideBar();
                vm.GetAssociatedZonesOnSideBar();
                $rootScope.getJobList();

                //$scope.ChangeZoneById(vm.ParamZoneId);
            });
    }

    vm.UpdateBio = function () {

        BioService.UpdateBio(vm.Bio.Bio)
            .then(function (data) {


            });
    }

    vm.UpdateDescription = function () {
        if (vm.SelectedDescriptionStatusItem != undefined) {
            vm.DescriptionToTranslate.StatusId = vm.SelectedDescriptionStatusItem.id;
        }
        else {
            vm.DescriptionToTranslate.StatusId = 17;
        }
        if (vm.NewDescription) {
            HelperService.AddDescription(vm.DescriptionToTranslate)
            .then(function (data) {
                vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });
        }
        else {
            HelperService.UpdateDescription(vm.DescriptionToTranslate)
                .then(function (data) {

                });
        }
    }

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Bio", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    vm.UpdateDescriptionStatusId = function () {
        if (vm.SelectedDescriptionStatusItem != undefined) {
            vm.DescriptionToTranslate.StatusId = vm.SelectedDescriptionStatusItem.id;
        }
        else {
            vm.DescriptionToTranslate.StatusId = 17;
        }
        if (vm.NewDescription) {
            HelperService.AddDescription(vm.DescriptionToTranslate)
            .then(function (data) {
                vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });
        }
        else {
            if (vm.SelectedDescriptionStatusItem != vm.PreviousDescriptionStatusItem) {
                vm.PreviousDescriptionStatusItem = vm.SelectedDescriptionStatusItem;
                HelperService.UpdateDescription(vm.DescriptionToTranslate)
                    .then(function (data) {

                    });
            }
        }
    }

    vm.GetDescriptionTranslated = function () {
        HelperService.GetDescriptionById(vm.Bio.DescriptionList[vm.ActiveDescriptionId].DescriptionId, $rootScope.LangForTranslationDestination)
                                .then(function (desc) {
                                    if (desc.success == false) {
                                        vm.DescriptionToTranslate = angular.copy(vm.Bio.DescriptionList[vm.ActiveDescriptionId]);
                                        vm.DescriptionToTranslate.LanguageCode = $rootScope.LangForTranslationDestination;
                                        vm.DescriptionToTranslate.IsDefaultLang = false;
                                        vm.DescriptionToTranslate.DescriptionTitle = '';
                                        vm.DescriptionToTranslate.Stick = '';
                                        vm.DescriptionToTranslate.Resume = '';
                                        vm.DescriptionToTranslate.Description = '';
                                        vm.DescriptionToTranslate.StatusTrad = $translate.instant("StatusId25");
                                        //init status
                                        vm.SelectedDescriptionStatusItem = $rootScope.StatusList4WorkflowDescriptionTranslationIdValue[0];
                                        vm.PreviousDescriptionStatusItem = angular.copy(vm.SelectedDescriptionStatusItem);
                                        vm.NewDescription = true;

                                    }
                                    else {
                                        vm.DescriptionToTranslate = desc;
                                        vm.SelectedDescriptionStatusItem = GetItemByFieldName(vm.DescriptionToTranslate.StatusId, 'id', $rootScope.StatusList4WorkflowDescriptionTranslationIdValue)[0];
                                        vm.PreviousDescriptionStatusItem = angular.copy(vm.SelectedDescriptionStatusItem);
                                        vm.NewDescription = false;
                                    }

                                });
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {
        promiseAddComment = SideBarService.AddComment(vm.Bio.SideBar.CommentEdit, vm.Bio.Bio.BioId, $stateParams.lang, $rootScope.EnumLinkType.Bio);

        promiseAddComment
         .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {
        console.log(vm.Bio);

        SideBarService.SaveDiffuseur($rootScope.Clients, vm.Bio.Bio.BioId, $stateParams.lang, $rootScope.EnumLinkType.Bio);
    };

    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVm(vm.Bio.DescriptionList[vm.ActiveDescriptionId].DescriptionId, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
            });
    }

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/traduction/bio?id=' + vm.Bio.Bio.BioId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }
    vm.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
            });
    }

    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces() {
        promiseAddComment = SideBarService.SaveAssociatedPlaces(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.AssociatedPlaces);
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedZones = data;
            });
    }

    $rootScope.SaveAssociatedZones = function SaveAssociatedZones() {
        promiseAddComment = SideBarService.SaveAssociatedZones(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.AssociatedZones);
    };

    $rootScope.SaveQualificationAssociees = function () {
        HelperService.SaveQualificationAssociees(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.SideBar.QualificationList);
    }

    $rootScope.SaveJobAssocie = function () {
        HelperService.SaveJobAssocie(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $rootScope.SideBar.bioVmProfessionTranslation);
    }

    vm.PreviousDesc = function () {
        if (vm.Bio.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
            vm.GetDescriptionTranslated();
        }
    }

    vm.NextDesc = function () {
        if (vm.Bio.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.Bio.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            vm.GetDescriptionVm();
            vm.GetDescriptionTranslated();
        }
    }

    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, $rootScope.EnumLinkType.Bio);
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareBioPracticalInfo', $translate.instant('emailShareBioPracticalInfo').replaceAll('&amp;', '&'), vm.Bio);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
}